import { Component } from '@angular/core';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';

@Component({
  selector: 'ag-search-condition-save-dialog',
  templateUrl: './search-condition-save-dialog.component.html',
  styleUrls: ['./search-condition-save-dialog.component.scss'],
})
export class SearchConditionSaveDialogComponent {
  name = '';

  constructor(public dialog: DialogRef) {}

  close(): void {
    this.dialog.close();
  }

  save(): void {
    if (!this.name.trim()) {
      return;
    }
    this.dialog.close({ name: this.name.trim() });
  }
}
